import React from 'react';

// Generic replacement for window.confirm() — styled to match the app's
// other modals instead of a native browser alert. Render once per page and
// drive it from a single `{ title, message, confirmLabel, danger, onConfirm }`
// state object; pass null/undefined to keep it closed.
const ConfirmModal = ({ open, title, message, confirmLabel = 'Confirm', danger = false, onConfirm, onCancel }) => {
  if (!open) return null;

  return (
    <div
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100 }}
      onClick={onCancel}
    >
      <div className="card" style={{ width: '380px', maxWidth: '90vw' }} onClick={e => e.stopPropagation()}>
        <h3 style={{ marginBottom: '12px' }}>{title}</h3>
        <p style={{ fontSize: '14px', color: 'var(--text-muted)', marginBottom: '20px', lineHeight: 1.5 }}>{message}</p>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
          <button type="button" className="btn" onClick={onCancel}>Cancel</button>
          <button
            type="button"
            className="btn btn-primary"
            style={danger ? { background: 'var(--danger-color)' } : undefined}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
